import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {SymbolValues} from "../server/BS2Data";
import {ReelSetBuilder} from "../utils/ReelSetBuilder";
import {LoopableList} from "../utils/LoopableList";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

/**
 * Created by jonas on 2022-06-10.
 */

export class BS2Statics {
    public static BOOSTED_BET_1: string = "BOOSTED_BET_1";
    public static BOOSTED_BET_2: string = "BOOSTED_BET_2";

    public static BOT_STICKY_WILD_IDX_VIS_AREA: number = 4;
    public static BOT_STICKY_WILD_IDX_WITH_BUFFER: number = 5;

    public static mainGameSpecialSymbolConfig = [
        {type: "S", amount: [3, 3, 3, 3, 3], exculdeWithSymbol: ["W"], maxAmountInView: 1},
        {type: "W", amount: [3, 3, 3, 3, 3], exculdeWithSymbol: ["S"], maxAmountInView: 1},
    ];

    public static superFSSpecialSymbolConfig = [
        {type: "S", amount: [3, 3, 3, 3, 3], exculdeWithSymbol: ["W"], maxAmountInView: 1},
        {type: "W", amount: [3, 3, 3, 3, 3], exculdeWithSymbol: ["S"], maxAmountInView: 1},
    ];


    public static LEVEL_REEL_SETS: string[][][] = [
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "L5"]}
        }, [{name: "LEVEL_0", symbols: BS2Statics.mainGameSpecialSymbolConfig}]).get("LEVEL_0")!,
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["M1", "M2", "M3", "M4", "H5", "L1", "L2", "L3", "L4",]}
        }, [{name: "LEVEL_1", symbols: BS2Statics.mainGameSpecialSymbolConfig}]).get("LEVEL_1")!,
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["M1", "M2", "M3", "H4", "H5", "L1", "L2", "L3"]}
        }, [{name: "LEVEL_2", symbols: BS2Statics.mainGameSpecialSymbolConfig}]).get("LEVEL_2")!,
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["M1", "M2", "H3", "H4", "H5", "L1", "L2"]}
        }, [{name: "LEVEL_3", symbols: BS2Statics.mainGameSpecialSymbolConfig}]).get("LEVEL_3")!,
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["M1", "H2", "H3", "H4", "H5", "L1"]}
        }, [{name: "LEVEL_4", symbols: BS2Statics.mainGameSpecialSymbolConfig}]).get("LEVEL_4")!,
        ReelSetBuilder.createSpinReels({
            amountOfReels: 5,
            maxVisibleSize: 5,
            fillerSymbols: {amount: [0, 0, 0, 0, 0], type: ["H1", "H2", "H3", "H4", "H5"]}
        }, [{name: "LEVEL_5", symbols: BS2Statics.superFSSpecialSymbolConfig}]).get("LEVEL_5")!
    ];

    public static DEFAULT_REEL_SET: string[] = ["M1", "M2", "M3", "M4", "M5", "L1", "L2", "L3", "L4", "L5"];

    public static FEATURE_BET_REEL_SET: string[][] = [
        ["H5", "EM", "EM", "EM", "EM", "EM", "EM"],
        ["H4", "EM", "EM", "EM", "EM", "EM", "EM", "EM"],
        ["H3", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM"],
        ["H2", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM"],
        ["H1", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM", "EM"],
    ];
    public static SYMBOLS = {
        S: "S",
        W: "W",
        L1: "L1",
        L2: "L2",
        L3: "L3",
        L4: "L4",
        L5: "L5",
        M1: "M1",
        M2: "M2",
        M3: "M3",
        M4: "M4",
        M5: "M5",
        H1: "H1",
        H2: "H2",
        H3: "H3",
        H4: "H4",
        H5: "H5",
        EM: "EM", //Special symbols for "empty" during feature buy
        X: "X", //Blank symbol used to denote removed avalanche symbols.
        Y: "Y",
        D: "D",
        G: "G"
    };
    public static LOW_SYMBOLS: string[] = [
        BS2Statics.SYMBOLS.L1,
        BS2Statics.SYMBOLS.L2,
        BS2Statics.SYMBOLS.L3,
        BS2Statics.SYMBOLS.L4,
        BS2Statics.SYMBOLS.L5
    ];
    public static MID_SYMBOLS: string[] = [
        BS2Statics.SYMBOLS.M1,
        BS2Statics.SYMBOLS.M2,
        BS2Statics.SYMBOLS.M3,
        BS2Statics.SYMBOLS.M4,
        BS2Statics.SYMBOLS.M5
    ];
    public static HIGH_SYMBOLS: string[] = [
        BS2Statics.SYMBOLS.H1,
        BS2Statics.SYMBOLS.H2,
        BS2Statics.SYMBOLS.H3,
        BS2Statics.SYMBOLS.H4,
        BS2Statics.SYMBOLS.H5
    ];

    public static SPLIT_SYMBOLS: string[] = [BS2Statics.SYMBOLS.D, BS2Statics.SYMBOLS.G];

    public static UPGRADE_NAMES: { [key: string]: string } = {
        L1: "M1",
        L2: "M2",
        L3: "M3",
        L4: "M4",
        L5: "M5",
        M1: "H1",
        M2: "H2",
        M3: "H3",
        M4: "H4",
        M5: "H5"
    }
    public static firstWinHighlightReel: number = 2;
    public static SYMBOL_SPRITE_WIDTH: number = 144;
    public static SYMBOL_SPRITE_HEIGHT: number = 104;
    public static SYMBOL_WIDTH: number = 144;
    public static SYMBOL_HEIGHT: number = 104;
    public static REEL_X_OFFSET: number = BS2Statics.SYMBOL_WIDTH;
    public static REEL_Y_OFFSET: number = BS2Statics.SYMBOL_HEIGHT;
    public static STEP_WIDTH: number = BS2Statics.SYMBOL_WIDTH;
    public static STEP_HEIGHT: number = BS2Statics.SYMBOL_HEIGHT;
    public static REEL_AREA_X_OFFSET: number = 73;
    public static REEL_AREA_Y_OFFSET: number = 114;
    public static NR_OF_REELS = 5;
    public static stepDuration: number = 0.03;
    public static reelStopDelay: number = BS2Statics.stepDuration * 6; //0.32
    public static reelStopDelayFastSpin: number = BS2Statics.stepDuration * 4;
    public static reelStopDelayQuickStop: number = BS2Statics.stepDuration * 2;
    public static stepSize: { x: number, y: number } = {
        x: 0,
        y: BS2Statics.SYMBOL_HEIGHT,
    }
    public static SYMBOL_DROP_DELAY = 0.1;
    public static SYMBOL_DROP_FAST_SPIN_DELAY = 0.04;
    public static FS_SYMBOL_DROP_DELAY = 0.2;
    public static FS_SYMBOL_DROP_FAST_SPIN_DELAY = 0.1;
    public static DROP_OUT_DURATION = 0.4;
    public static DROP_IN_DURATION: number = 0.4;
    public static COLLAPSE_DURATION: number = 0.15;
    public static COLLAPSE_DELAY: number = 0.02;
    public static FILL_UP_DROP_DURATION: number = 0.05;
    public static FILL_UP_ROW_DELAY: number = 0.05;
    public static FILL_UP_SYMBOL_DELAY: number = 0.05;
    public static FILL_UP_SYMBOL_NEAR_WIN_DELAY: number = 0.5;
    public static WIN_SYMBOL_DELAY: number = 0.05;
    public static LOCK_DELAY: number = 0.1;
    public static SYMBOL_WIN_DELAY: number = 0.05;
    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 60,
        amplitudeEase: "none",
        timingEase: "none",
    });
    public static explodeWiggle = CustomWiggle.create("explodeWiggle", {
        wiggles: 20,
        amplitudeEase: "none",
        timingEase: "none",
    });
    public static defaultSymbolValues: SymbolValues = {
        "M1": {
            "3": 10,
            "4": 20,
            "5": 30
        },
        "M2": {
            "3": 8,
            "4": 16,
            "5": 24
        },
        "L1": {
            "3": 4,
            "4": 8,
            "5": 12
        },
        "M3": {
            "3": 8,
            "4": 16,
            "5": 24
        },
        "L2": {
            "3": 2,
            "4": 4,
            "5": 6
        },
        "M4": {
            "3": 6,
            "4": 12,
            "5": 18
        },
        "L3": {
            "3": 2,
            "4": 4,
            "5": 6
        },
        "M5": {
            "3": 6,
            "4": 12,
            "5": 18
        },
        "L4": {
            "3": 1,
            "4": 2,
            "5": 3
        },
        "H1": {
            "3": 50,
            "4": 80,
            "5": 160
        },
        "L5": {
            "3": 1,
            "4": 2,
            "5": 3
        },
        "H2": {
            "3": 40,
            "4": 60,
            "5": 120
        },
        "H3": {
            "3": 30,
            "4": 50,
            "5": 100
        },
        "H4": {
            "3": 20,
            "4": 40,
            "5": 80
        },
        "H5": {
            "3": 15,
            "4": 30,
            "5": 60
        }
    }
    public static EM_SYMBOLS: LoopableList<string> = new LoopableList<string>([
        "EM", "EM", "EM", "EM", "EM", "EM",
        "EM2", "EM2", "EM2", "EM2", "EM2", "EM2",
        "EM3", "EM3", "EM3", "EM3", "EM3", "EM3",
    ]).setRandomizeAtWrapAround(true);

    constructor() {
    }

    public static getShortScreenOffset(): number {
        return NolimitApplication.isLandscape ? 19 : 0;
    }

    public static getRemoveSymbols(currentLevel: number): string[] {
        let result: string[] = BS2Statics.LOW_SYMBOLS.concat();
        result.reverse();
        result.splice(currentLevel);
        return result;
    }

    public static getUpgradeSymbols(currentLevel: number): string[] {
        let result: string[] = BS2Statics.MID_SYMBOLS.concat();
        result.reverse();
        result.splice(currentLevel);
        return result;
    }
}